import {
  ComponentNavigationNavbar,
  Enum_Componentnavigationlinklist_Align,
  Enum_Componentnavigationlinklist_Orientation,
  Enum_Componentsectionspagepreviewlist_Variant,
  Enum_Menuitem_Variation,
} from "../graphql/generated/graphql";
import { wrapperMarginLargeDefaultLayout } from "./wrapper";
import { colorsBgSlateTextDefault } from "./colors";
import { image } from "./image";

export const menu: ComponentNavigationNavbar = {
  id: "1",
  menu: {
    data: {
      attributes: {
        menuItems: {
          __typename: "MenuItemRelationResponseCollection",
          data: [
            {
              __typename: "MenuItemEntity",
              id: "3",
              attributes: {
                __typename: "MenuItem",
                page: {
                  __typename: "PageEntityResponse",
                  data: {
                    __typename: "PageEntity",
                    attributes: {
                      __typename: "Page",
                      path: "/page-two",
                    },
                  },
                },
                label: "Produkte",
                sort: 1,
                externalUrl: null,
                linkTarget: {
                  __typename: "ValueEntityResponse",
                  data: null,
                },
                components: [
                  {
                    __typename: "ComponentNavigationLinkList",
                    id: "2",
                    label: "Camping",
                    externalUrl: null,
                    orientation: null,
                    page: {
                      __typename: "PageEntityResponse",
                      data: {
                        __typename: "PageEntity",
                        attributes: {
                          __typename: "Page",
                          path: "/fitness/trainingsziel/ausdauer",
                        },
                      },
                    },
                    linkTarget: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    textSize: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    links: [
                      {
                        __typename: "ComponentNavigationLink",
                        id: "4",
                        label: "Foo",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: {
                            __typename: "PageEntity",
                            attributes: {
                              __typename: "Page",
                              path: "/page-one",
                            },
                          },
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "3",
                        label: "Bar",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: {
                            __typename: "PageEntity",
                            attributes: {
                              __typename: "Page",
                              path: "/page-two",
                            },
                          },
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                    ],
                  },
                  {
                    __typename: "ComponentNavigationLinkList",
                    id: "3",
                    label: "Another one",
                    externalUrl: null,
                    orientation: null,
                    page: {
                      __typename: "PageEntityResponse",
                      data: null,
                    },
                    linkTarget: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    textSize: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    links: [
                      {
                        __typename: "ComponentNavigationLink",
                        id: "6",
                        label: "Some ",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "5",
                        label: "Some Some",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                    ],
                  },
                ],
              },
            },
            {
              __typename: "MenuItemEntity",
              id: "18",
              attributes: {
                __typename: "MenuItem",
                page: {
                  __typename: "PageEntityResponse",
                  data: null,
                },
                label: "Guides & Blog",
                sort: 2,
                externalUrl: null,
                linkTarget: {
                  __typename: "ValueEntityResponse",
                  data: null,
                },
                components: [
                  {
                    __typename: "ComponentNavigationLinkList",
                    id: "8",
                    label: "Fitness",
                    externalUrl: null,
                    orientation: null,
                    page: {
                      __typename: "PageEntityResponse",
                      data: {
                        __typename: "PageEntity",
                        attributes: {
                          __typename: "Page",
                          path: "/fitness",
                        },
                      },
                    },
                    linkTarget: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    textSize: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    links: [
                      {
                        __typename: "ComponentNavigationLink",
                        id: "16",
                        label: "Ratgeber",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "19",
                        label: "Abnehmen",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "15",
                        label: "Ausdauer",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: {
                            __typename: "PageEntity",
                            attributes: {
                              __typename: "Page",
                              path: "/fitness/trainingsziel/ausdauer",
                            },
                          },
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                    ],
                  },
                  {
                    __typename: "ComponentNavigationLinkList",
                    id: "6",
                    label: "Camping",
                    externalUrl: null,
                    orientation: null,
                    page: {
                      __typename: "PageEntityResponse",
                      data: null,
                    },
                    linkTarget: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    textSize: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    links: [
                      {
                        __typename: "ComponentNavigationLink",
                        id: "13",
                        label: "Zelte",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "17",
                        label: "Ratgeber",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                    ],
                  },
                  {
                    __typename: "ComponentNavigationLinkList",
                    id: "7",
                    label: "Dutch Oven",
                    externalUrl: null,
                    orientation: null,
                    page: {
                      __typename: "PageEntityResponse",
                      data: null,
                    },
                    linkTarget: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    textSize: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    links: [
                      {
                        __typename: "ComponentNavigationLink",
                        id: "11",
                        label: "Einfache Rezepte",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "18",
                        label: "Beliebte Rezepte",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "14",
                        label: "Rezepttypen",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "12",
                        label: "Einsatzgebiete",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                    ],
                  },
                  {
                    __typename: "ComponentSectionsPagePreviewList",
                    id: "5",
                    title: "Latest Content",
                    hideSynopsis: true,
                    variant:
                      Enum_Componentsectionspagepreviewlist_Variant.Navbar,
                    pages: {
                      __typename: "PageRelationResponseCollection",
                      data: [
                        {
                          __typename: "PageEntity",
                          id: "2",
                          attributes: {
                            __typename: "Page",
                            path: "/page-one",
                            publicationDate: "2022-08-30T10:00:00.000Z",
                            publishedAt: "2022-08-22T20:47:56.386Z",
                            synopsis: "A page",
                            title: "Page One",
                            tags: {
                              __typename: "TagRelationResponseCollection",
                              data: [],
                            },
                            image: image,
                          },
                        },
                        {
                          __typename: "PageEntity",
                          id: "3",
                          attributes: {
                            __typename: "Page",
                            path: "/page-two",
                            publicationDate: null,
                            publishedAt: "2022-08-22T20:47:51.744Z",
                            synopsis:
                              "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
                            title: "Page two",
                            tags: {
                              __typename: "TagRelationResponseCollection",
                              data: [],
                            },
                            image: image,
                          },
                        },
                      ],
                    },
                    tags: {
                      __typename: "TagRelationResponseCollection",
                      data: [],
                    },
                    columns: 2,
                  },
                ],
              },
            },
            {
              __typename: "MenuItemEntity",
              id: "19",
              attributes: {
                __typename: "MenuItem",
                page: {
                  __typename: "PageEntityResponse",
                  data: null,
                },
                label: "Story",
                sort: 3,
                externalUrl: null,
                linkTarget: {
                  __typename: "ValueEntityResponse",
                  data: null,
                },
                components: [],
              },
            },
            {
              __typename: "MenuItemEntity",
              id: "20",
              attributes: {
                __typename: "MenuItem",
                page: {
                  __typename: "PageEntityResponse",
                  data: null,
                },
                label: "Markenbotschafter",
                sort: 4,
                externalUrl: null,
                linkTarget: {
                  __typename: "ValueEntityResponse",
                  data: null,
                },
                components: [],
              },
            },
            {
              __typename: "MenuItemEntity",
              id: "21",
              attributes: {
                __typename: "MenuItem",
                page: {
                  __typename: "PageEntityResponse",
                  data: null,
                },
                label: "Service",
                variation: Enum_Menuitem_Variation.Dropdown,
                sort: 5,
                externalUrl: null,
                linkTarget: {
                  __typename: "ValueEntityResponse",
                  data: null,
                },
                components: [
                  {
                    __typename: "ComponentNavigationLinkList",
                    id: "9",
                    label: null,
                    externalUrl: null,
                    align: Enum_Componentnavigationlinklist_Align.Left,
                    orientation:
                      Enum_Componentnavigationlinklist_Orientation.Vertical,
                    page: {
                      __typename: "PageEntityResponse",
                      data: null,
                    },
                    linkTarget: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    textSize: {
                      __typename: "ValueEntityResponse",
                      data: null,
                    },
                    links: [
                      {
                        __typename: "ComponentNavigationLink",
                        id: "20",
                        label: "Analytics",
                        description:
                          "Get a better understanding of your traffic",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "21",
                        label: "Engagement",
                        description: "Speak directly to your customers",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "22",
                        label: "Kontakt",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                      {
                        __typename: "ComponentNavigationLink",
                        id: "23",
                        label: "Kinomap",
                        externalUrl: null,
                        page: {
                          __typename: "PageEntityResponse",
                          data: null,
                        },
                        image: {
                          __typename: "UploadFileEntityResponse",
                          data: null,
                        },
                        linkTarget: {
                          __typename: "ValueEntityResponse",
                          data: null,
                        },
                      },
                    ],
                  },
                ],
              },
            },
          ],
        },
      },
    },
  },
};
